import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-lsa-dark text-white pt-12 pb-16 px-5 flex flex-col items-center text-center" data-id="element-109">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="max-w-xl w-full flex flex-col items-center" data-id="element-110">
        <div className="inline-block bg-white/10 border border-white/20 rounded-full px-4 py-1.5 text-xs font-semibold mb-6 tracking-wide" data-id="element-111">
          🇦🇷 Método Completo · Edición 2026
        </div>

        <h1 className="text-[32px] sm:text-[40px] leading-[1.1] font-extrabold mb-6 tracking-tight uppercase" data-id="element-112">
          Tu Lenguaje de señas{' '}
          <span className="relative inline-block text-lsa-cyan" data-id="element-113">
            Resuelto
            <span className="absolute left-0 -bottom-1 h-1 w-full rounded-full bg-lsa-cyan/60" data-id="element-114" />
          </span>
        </h1>

        <motion.img src="https://cdn.magicpatterns.com/uploads/i1iQa3ASMKatuSaXvYKCqz/Untitled_design.png" alt="Sistema LSA Fácil — libro completo con material de práctica, tarjetas y planillas de seguimiento" className="w-full max-w-sm mx-auto mb-6 drop-shadow-2xl select-none pointer-events-none" style={{
        animation: 'lsa-float 4s ease-in-out infinite'
      }} initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} data-id="element-115" />

        <p className="text-white/80 text-[15px] sm:text-base leading-relaxed mb-8 max-w-md" data-id="element-116">
          El sistema paso a paso para familias, docentes y traductores que
          quieren comunicarse de verdad.
        </p>

        <div className="w-full flex flex-col gap-3 mb-6" data-id="element-117">
          <button onClick={scrollToPricing} className="w-full bg-lsa-cyan hover:brightness-110 text-lsa-deep h-[56px] rounded-xl font-bold text-[17px] transition-all shadow-lg shadow-lsa-cyan/30 flex items-center justify-center gap-2" data-id="element-118">
            <span className="text-xl" data-id="element-119">🤟</span> Quiero el Sistema LSA Fácil
          </button>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-2 text-xs sm:text-sm text-white/70 font-medium" data-id="element-120">
          <span className="flex items-center gap-1" data-id="element-121">⭐ 4.9/5</span>
          <span className="hidden sm:inline" data-id="element-122">·</span>
          <span data-id="element-123">+1.200 personas</span>
          <span className="hidden sm:inline" data-id="element-124">·</span>
          <span className="flex items-center gap-1" data-id="element-125">📦 +2000 señas</span>
          <span className="hidden sm:inline" data-id="element-126">·</span>
          <span className="flex items-center gap-1" data-id="element-127">🔒 Garantía 7 días</span>
        </div>
      </motion.div>
    </section>;
}